/* 画面TOPにスクロール */
import React from 'react';
import { scrollPageTop } from '../Scroll';
var ScrollTopButton = function () {
    return (React.createElement("div", null,
        React.createElement("a", { className: "btn btn-main-color btn-xl", onClick: scrollPageTop }, "\u25B3TOP")));
};
export default ScrollTopButton;
